import { IConfig } from "@interfaces/config.interface";

export const Config: IConfig = {
    warningsDialogHtml: "warnings-dialog.html",
    ribbonButtonDialogHtml: "ribbon-button-dialog.html",
    loginDialogHtml: "login-dialog.html",
    keywordProximityCount: 200,
    ssoLoginModalBackoffHours: [0, 0, 4],
    version: "1.5.7.0",
    timeouts: {
        common: 3000,
        dialog: 15000,
        localRules: 400,
        allowEmailSend: 600,
        updateRelationships: 500,
        rollbackRelationship: 500,
        onSendEvent: 1000
    },
    storageKeys: {
        statsInfo: "STATS_INFO",
        configSync: "CONFIG_SYNC",
        ssoLoginModalLastShown: "SSO_LAST_SHOWN"
    },
    languageDetectionConfig: {
        candidateCount: 2,
        scoreThreshold: 0.53,
    },
}
